// extracted by mini-css-extract-plugin
export default {"report":"CarbonPoliciesTable_report__kV5dK"};